// extracted by css-extract-rspack-plugin
export default {"staleContentWarning":"CommentBox-module__staleContentWarning__GVqdr","commentBoxContainer":"CommentBox-module__commentBoxContainer__fVeTk"};